import React from "react";
import "../styles/about.css";

import {
  FaCheckCircle,
  FaUsers,
  FaArrowRight,
} from "react-icons/fa";

import dashboard from "../assets/images/accounts-dashboard-1.png";

const About = () => {
  return (
    <section className="about" id="about">

      <div className="about-container">

        {/* LEFT */}

        <div className="about-content">

          <span className="about-tag">
            ABOUT ITWORLD
          </span>

          <h2>
            Driving Digital Transformation
            <br />
            For Fuel Stations
          </h2>

          <p>
            ITWORLD specializes in complete technology solutions
            for petrol pumps across Pakistan. We combine software,
            automation and hardware into one integrated platform,
            helping fuel stations improve efficiency, accuracy,
            security and customer satisfaction.
          </p>

          <div className="about-features">

            <div>
              <FaCheckCircle />
              Accounts ERP Software
            </div>

            <div>
              <FaCheckCircle />
              Live Nozzle Automation
            </div>

            <div>
              <FaCheckCircle />
              Fuel Receipt Printing
            </div>

            <div>
              <FaCheckCircle />
              External Display Systems
            </div>

            <div>
              <FaCheckCircle />
              Inventory & Tank Monitoring
            </div>

            <div>
              <FaCheckCircle />
              24/7 Technical Support
            </div>

          </div>

          <button className="about-btn">

            Learn More

            <FaArrowRight />

          </button>

        </div>

        {/* RIGHT */}

        <div className="about-image">

          <img
            src={dashboard}
            alt="Dashboard"
          />

          <div className="experience-card">

            <FaUsers />

            <div>

              <h3>100+</h3>

              <span>Happy Clients</span>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default About;